import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { pdf } from '@react-pdf/renderer';
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import UserService from "../controllers/UserService";
import AuthService from "../controllers/AuthService";
Font.register({ family: 'SarabunRegular', src: '/font/Sarabun-Regular.ttf' });
Font.register({ family: 'SarabunBold', src: '/font/Sarabun-Bold.ttf' });


const ExportReportFriendshipTarget = props => {
    const { target, roomId, studentId } = useParams();
    // const [school, setSchool] = useState('');
    // const [teacher, setTeacher] = useState('');
    const [studentNameState, setStudentNameState] = useState('');
    // const [data, setData] = useState({});
    const printedBy = AuthService.getUserFullName();
    let logo = UserService.getLogoUrl();
    let dateString = '';
    let headerText = 'กิจกรรม Friendship';
    let room = '';

    let data = {}
    let teacher = '';
    let studentName = '';
    let school = '';

    const generateDate = (dateTime) => {
        // console(formattedDate, formattedMonth);
        var months_th = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",];
        var temp = dateTime.getFullYear() + 543;
        return dateTime.getDate() + ' ' + months_th[dateTime.getMonth()] + ' ' + temp;
    }
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    var dateTemp = new Date(yyyy + '-' + mm + '-' + dd);
    dateString = generateDate(dateTemp);

    useEffect(() => {
        try {
            UserService.getRoomDetail(roomId).then((response) => {
                console.log(response);
                const roomData = response.data.data
                if (roomData.domain && roomData.domain.displayName) {
                    // setSchool(roomData.domain.displayName)
                    school = roomData.domain.displayName;
                }
                if (roomData.teachers && roomData.teachers[0] && roomData.teachers[0].fullName) {
                    // setTeacher(roomData.teachers[0].fullName)
                    teacher = roomData.teachers[0].fullName
                }
                // filter.roomId = roomId;
                // filter = {
                //     'status': 'RUNNING',
                //     'domain': AuthService.getCurrentUser().domain.name,
                //     'roomId': roomId,
                //     'year' : response.data.data.year,
                //     'term' : response.data.data.term
                // }
            }).then(() => {
                UserService.getUserById(studentId).then((response) => {
                    console.log(response.data.data);
                    const userData = response.data.data
                    setStudentNameState(userData.fullName)
                    studentName = userData.fullName;
                    if (typeof userData.room !== 'undefined') {
                        room = userData.room.displayName;
                    }

                });
                UserService.getStrengths().then((response) => {
                    return response.data.data
                }).then((apiStrengths) => {
                    UserService.getFriendShipList(studentId, { roomId }).then(async (response) => {
                        if (response.data.status.code === 'SUCCESS' && response.data.data && response.data && response.data.data[0] && response.data.data[0].others) {
                            const FSData = response.data.data[0].others
                            const meData = FSData.filter(function (d) { return d.user.id === studentId })[0];
                            let teacherData = FSData.filter(function (d) { return d.user.roles.includes("TEACHER") && d.answerAt !== null });
                            // console.log('teacherData');
                            // console.log(FSData);
                            if (teacherData[0]) {
                                teacherData = teacherData[0];
                            } else {

                                teacherData = FSData.filter(function (d) { return d.user.roles.includes("TEACHER") })[0];
                            }

                            const friendsData = FSData.filter(function (d) { return !d.user.roles.includes("TEACHER") && d.user.id !== studentId });
                            let resultMeData = null
                            let resultTeacherData = null
                            let resultFriendsData = null
                            if (meData && meData.answerAt) {
                                const str0 = apiStrengths.filter(function (strength) { return strength.id === meData.answers[0].values[0] })[0];
                                const str1 = apiStrengths.filter(function (strength) { return strength.id === meData.answers[1].values[0] })[0];
                                const str2 = apiStrengths.filter(function (strength) { return strength.id === meData.answers[2].values[0] })[0];
                                if (str0 && str1 && str2) {
                                    resultMeData = {
                                        'images': [
                                            `/images/strengths/cards/${str0.id}.png`,
                                            `/images/strengths/cards/${str1.id}.png`,
                                            `/images/strengths/cards/${str2.id}.png`,
                                        ],
                                        'strengths': [
                                            str0.name,
                                            str1.name,
                                            str2.name
                                        ],
                                        'strengths_description': [
                                            processContent(str0.description),
                                            processContent(str1.description),
                                            processContent(str2.description),
                                            meData.answers && meData.answers[3] && meData.answers[3].values && meData.answers[3].values[0] ? processContent(meData.answers[3].values[0]) : ''
                                        ]
                                    }
                                }
                            }
                            if (teacherData && teacherData.answerAt) {
                                const str0 = apiStrengths.filter(function (strength) { return strength.id === teacherData.answers[0].values[0] })[0];
                                const str1 = apiStrengths.filter(function (strength) { return strength.id === teacherData.answers[1].values[0] })[0];
                                const str2 = apiStrengths.filter(function (strength) { return strength.id === teacherData.answers[2].values[0] })[0];
                                if (str0 && str1 && str2) {
                                    resultTeacherData = {
                                        'images': [
                                            str0 ? `/images/strengths/cards/${str0.id}.png` : '',
                                            str1 ? `/images/strengths/cards/${str1.id}.png` : '',
                                            str2 ? `/images/strengths/cards/${str2.id}.png` : '',
                                        ],
                                        'strengths': [
                                            str0 ? str0.name : '',
                                            str1 ? str1.name : '',
                                            str2 ? str2.name : ''
                                        ],
                                        'strengths_description': [
                                            str0 ? processContent(str0.description) : '',
                                            str1 ? processContent(str1.description) : '',
                                            str2 ? processContent(str2.description) : '',
                                            teacherData.answers && teacherData.answers[3] && teacherData.answers[3].values && teacherData.answers[3].values[0] ? processContent(teacherData.answers[3].values[0]) : ''
                                        ]
                                    }
                                }
                            }
                            if (friendsData && friendsData.length > 0) {
                                let newFriendAns = [];
                                let friendCommentAns = []
                                friendsData.forEach(function (item, i, arr) {
                                    console.log(item, 'item')
                                    if (item.answerAt) {
                                        let newAns = {
                                            'images': [],
                                            'strengths': [],
                                            'strengths_description': []
                                        };
                                        const answerStrength1 = item.answers[0].values[0]
                                        const answerStrength2 = item.answers[1].values[0]
                                        const answerStrength3 = item.answers[2].values[0]

                                        const str0 = apiStrengths.filter(function (strength) { return strength.id === answerStrength1 })[0];
                                        const str1 = apiStrengths.filter(function (strength) { return strength.id === answerStrength2 })[0];
                                        const str2 = apiStrengths.filter(function (strength) { return strength.id === answerStrength3 })[0];

                                        newAns.images.push(`/images/strengths/cards/${answerStrength1}.png`);
                                        newAns.images.push(`/images/strengths/cards/${answerStrength2}.png`);
                                        newAns.images.push(`/images/strengths/cards/${answerStrength3}.png`);

                                        newAns.strengths.push(str0.name);
                                        newAns.strengths.push(str1.name);
                                        newAns.strengths.push(str2.name);

                                        newAns.strengths_description.push(processContent(str0.description));
                                        newAns.strengths_description.push(processContent(str1.description));
                                        newAns.strengths_description.push(processContent(str2.description));

                                        newFriendAns.push(newAns);

                                        const answerText = item.answers.filter(function (d) { return d.type === 'text' })[0];
                                        if (answerText) {
                                            const realAnswer = answerText.values[0]
                                            friendCommentAns.push(processContent(realAnswer));
                                        }
                                    }
                                });
                                resultFriendsData = {
                                    'friendChooseStrength': newFriendAns,
                                    'friendComment': friendCommentAns
                                }
                            }
                            data = {
                                'me': resultMeData,
                                'teacher': resultTeacherData,
                                'friends': resultFriendsData
                            }
                        }
                        return true
                    }).then(async () => {
                        let fileName = studentName.replace(/ /g, '_') + '_friendship_room' + room.replace(/ม.|ป.| /g, '_');
                        await savePdf(StudentReport(), fileName)
                        setTimeout(() => { window.close(); }, 2000)
                    });
                });
            });
        } catch (error) {

        }
    }, []);

    const renderFriendCommentToMe = (comments) => {
        const data = [];
        for (let i = 0; i < comments.length; i++) {
            data.push(
                <View style={styles.ansBox} wrap={false} key={i}>
                    <Text style={styles.normalText}>
                        {comments[i]}
                    </Text>
                </View>
            );
        }
        return data;
    }

    const renderFriendChooseStrengthToMe = (strengths) => {
        const data = [];
        for (let i = 0; i < strengths.length; i++) {
            console.log('strengths[i]', strengths[i]);
            if (i > 0) {
                data.push(<Text break />);
            }
            data.push(
                <View>
                    <View wrap>
                        <View style={styles.divRow} breaks>
                            <Text style={styles.titleCenter}>Friendship - มุมมองเพื่อน</Text>
                        </View>
                        <View style={styles.divRow}>
                            <Text style={styles.titleBlueCenter}>อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา</Text>
                        </View>
                        <View style={styles.divRow}>
                            {(strengths[i].images[0]) && (
                                <View style={styles.width33}>
                                    <Image style={styles.image2} src={strengths[i].images[0] ? strengths[i].images[0] : ''} />
                                </View>
                            )}
                            {(strengths[i].images[1]) && (
                                <View style={styles.width33}>
                                    <Image style={styles.image2} src={strengths[i].images[1] ? strengths[i].images[1] : ''} />
                                </View>
                            )}
                            {(strengths[i].images[2]) && (
                                <View style={styles.width33}>
                                    <Image style={styles.image2} src={strengths[i].images[2] ? strengths[i].images[2] : ''} />
                                </View>
                            )}
                        </View>

                        {(strengths[i].strengths[0]) && (
                            <View>
                                <View style={styles.divRow}>
                                    <Text style={styles.titleCenter}> {strengths[i].strengths[0] ? strengths[i].strengths[0] : ''} </Text>
                                </View>
                                <View style={styles.ansBox} wrap={false}>
                                    <Text style={styles.normalText}> {strengths[i].strengths_description[0] ? strengths[i].strengths_description[0] : ''} </Text>
                                </View>
                            </View>
                        )}

                        {(strengths[i].strengths[1]) && (
                            <View>
                                <View style={styles.divRow}>
                                    <Text style={styles.titleCenter}> {strengths[i].strengths[1] ? strengths[i].strengths[1] : ''} </Text>
                                </View>
                                <View style={styles.ansBox} wrap={false}>
                                    <Text style={styles.normalText}>
                                        {strengths[i].strengths_description[1] ? strengths[i].strengths_description[1] : ''}
                                    </Text>
                                </View>
                            </View>
                        )}

                        {(strengths[i].strengths[2]) && (
                            <View>
                                <View style={styles.divRow}>
                                    <Text style={styles.titleCenter}> {strengths[i].strengths[2] ? strengths[i].strengths[2] : ''} </Text>
                                </View>
                                <View style={styles.ansBox} wrap={false}>
                                    <Text style={styles.normalText}> {strengths[i].strengths_description[2] ? strengths[i].strengths_description[2] : ''}</Text>
                                </View>
                            </View>
                        )}
                    </View>
                </View>
            );
        }
        return data;
    }

    const StudentReport = () => {
        return (
            <Document>
                <Page size="A4" style={styles.page} wrap>
                    <View style={styles.header100} fixed>
                        <View style={styles.logo1}>
                            <Image style={styles.image} src={logo} />
                        </View>
                        <View style={styles.THL1}>
                            <Text style={styles.HLB}>{school}</Text>
                            <Text style={styles.HLR}>สรุปกิจกรรม : {dateString} ครูประจำชั้น : {teacher}</Text>
                        </View>
                        <View style={styles.THL2}>
                            <Text style={styles.HLB}>{headerText} {room}</Text>
                            <Text style={styles.HLR}>ผู้ออกรายงาน : {printedBy}</Text>
                        </View>
                    </View>
                    <View style={styles.divRow} fixed>
                        <View style={styles.headerLeft}>
                            <Text style={styles.textBlue}>รายงานของ : {studentName}</Text>
                        </View>
                        <View style={styles.boxRight}>
                            <View style={styles.icon1}>
                            </View>
                            <View style={styles.width50}>
                                <Text style={styles.textBlue}></Text>
                            </View>
                        </View>
                    </View>

                    {((target === 'me' || target === 'all') && data.me) && (
                        <View>
                            <View style={styles.divRow} breaks>
                                <Text style={styles.titleCenter}>Friendship - มุมมองตัวเอง</Text>
                            </View>
                            <View style={styles.divRow}>
                                <View style={styles.width33}>
                                    <Image style={styles.image2} src={data.me && data.me.images ? data.me.images[0] : ''} />
                                </View>
                                <View style={styles.width33}>
                                    <Image style={styles.image2} src={data.me && data.me.images ? data.me.images[1] : ''} />
                                </View>
                                <View style={styles.width33}>
                                    <Image style={styles.image2} src={data.me && data.me.images ? data.me.images[2] : ''} />
                                </View>
                            </View>
                            <View style={styles.divRow}>
                                <Text style={styles.titleBlueCenter}>{data.me && data.me.strengths ? data.me.strengths[0] : ''} </Text>
                            </View>
                            <View style={styles.ansBox} wrap={false}>
                                <Text style={styles.normalText}>{data.me && data.me.strengths_description ? data.me.strengths_description[0] : ''}</Text>
                            </View>
                            <View style={styles.divRow}>
                                <Text style={styles.titleBlueCenter}>{data.me && data.me.strengths ? data.me.strengths[1] : ''} </Text>
                            </View>
                            <View style={styles.ansBox} wrap={false}>
                                <Text style={styles.normalText}>{data.me && data.me.strengths_description ? data.me.strengths_description[1] : ''}</Text>
                            </View>
                            <View style={styles.divRow}>
                                <Text style={styles.titleBlueCenter}>{data.me && data.me.strengths ? data.me.strengths[2] : ''} </Text>
                            </View>
                            <View style={styles.ansBox} wrap={false}>
                                <Text style={styles.normalText}>{data.me && data.me.strengths_description ? data.me.strengths_description[2] : ''}</Text>
                            </View>
                            <View style={styles.divRow} breaks>
                                <Text style={styles.titleCenter}>เหตุการณ์ที่ทำให้เรามองเห็นอุปนิสัยเชิงบวกของตัวเอง</Text>
                            </View>
                            <View style={styles.lastAnsBox} wrap={false}>
                                <Text style={styles.normalText}>{data.me && data.me.strengths_description ? data.me.strengths_description[3] : ''}</Text>
                            </View>
                        </View>
                    )}

                    {(target === 'all' && data.me) && (
                        <Text break />
                    )}

                    {((target === 'teacher' || target === 'all') && data.teacher) && (
                        <View>
                            <View wrap>
                                <View style={styles.divRow} breaks>
                                    <Text style={styles.titleCenter}>Friendship - มุมมองคุณครู</Text>
                                </View>
                                <View style={styles.divRow}>
                                    <View style={styles.width33}>
                                        <Image style={styles.image2} src={data.teacher && data.teacher.images ? data.teacher.images[0] : ''} />
                                    </View>
                                    <View style={styles.width33}>
                                        <Image style={styles.image2} src={data.teacher && data.teacher.images ? data.teacher.images[1] : ''} />
                                    </View>
                                    <View style={styles.width33}>
                                        <Image style={styles.image2} src={data.teacher && data.teacher.images ? data.teacher.images[2] : ''} />
                                    </View>
                                </View>
                                <View style={styles.divRow}>
                                    <Text style={styles.titleBlueCenter}>{data.teacher && data.teacher.strengths ? data.teacher.strengths[0] : ''} </Text>
                                </View>
                                <View style={styles.ansBox} wrap={false}>
                                    <Text style={styles.normalText}>{data.teacher && data.teacher.strengths_description ? data.teacher.strengths_description[0] : ''}</Text>
                                </View>
                                <View style={styles.divRow}>
                                    <Text style={styles.titleBlueCenter}>{data.teacher && data.teacher.strengths ? data.teacher.strengths[1] : ''} </Text>
                                </View>
                                <View style={styles.ansBox} wrap={false}>
                                    <Text style={styles.normalText}>{data.teacher && data.teacher.strengths_description ? data.teacher.strengths_description[1] : ''}</Text>
                                </View>
                                <View style={styles.divRow}>
                                    <Text style={styles.titleBlueCenter}>{data.teacher && data.teacher.strengths ? data.teacher.strengths[2] : ''} </Text>
                                </View>
                                <View style={styles.ansBox} wrap={false}>
                                    <Text style={styles.normalText}>{data.teacher && data.teacher.strengths_description ? data.teacher.strengths_description[2] : ''}</Text>
                                </View>
                                <View style={styles.divRow} breaks>
                                    <Text style={styles.titleCenter}>เหตุการณ์ที่ทำให้เรามองเห็นอุปนิสัยเชิงบวกของตัวเอง</Text>
                                </View>
                                <View style={styles.lastAnsBox} wrap={false}>
                                    <Text style={styles.normalText}>{data.teacher && data.teacher.strengths_description ? data.teacher.strengths_description[3] : ''}</Text>
                                </View>
                            </View>
                        </View>
                    )}

                    {(target === 'all' && data.teacher) && (
                        <Text break />
                    )}

                    {(target === 'friends' || target === 'all') && (
                        <View>
                            {data.friends.friendChooseStrength.length > 0 ? renderFriendChooseStrengthToMe(data.friends.friendChooseStrength) : null}

                            <Text break />
                            <View>
                                <View wrap>
                                    <View style={styles.divRow2} breaks>
                                        <Text style={styles.titleCenter}>เหตุการณ์ที่ทำให้เพื่อนๆ มองเห็นอุปนิสัยเชิงบวกของเรา</Text>
                                    </View>
                                    {data?.friends?.friendComment ? renderFriendCommentToMe(data?.friends?.friendComment) : null}
                                </View>
                            </View>

                        </View>
                    )}

                    <View style={styles.footer} fixed>
                        <View style={styles.headerLeft}>
                            <Text style={styles.footerTextL} >ออกโดยบริษัท MINDSET MAKER CO., LTD.</Text>
                        </View>
                        <View style={styles.headerRight}>
                            <Text style={styles.footerTextR} render={({ pageNumber, totalPages }) => (
                                `หน้า : ${pageNumber}/${totalPages}`
                            )} fixed />
                        </View>
                    </View>
                </Page>
            </Document>
        )
    }
    const saveBlob = (blob, filename) => {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
    };


    const savePdf = async (document, filename) => {
        saveBlob(await pdf(document).toBlob(), filename);
    };


    const regex = /(<([^>]+)>)/ig;
    const regex1 = /\&nbsp;/g;
    const regex2 = /  +/g;
    const regex3 = /[\u202F]/g;
    const regex4 = /\ /g;
    const processContent = (ctx) => {

        
        if (ctx !== undefined) {
            ctx = ctx.replace(regex, ' ');
            ctx = ctx.replace(regex1, ' ');
            ctx = ctx.replace(regex2, ' ');
            ctx = ctx.replace(regex3, ' ');
            ctx = ctx.replace(regex4, ' ');          
          
           try {
                ctx = decodeURI(ctx);
            }
            catch(err) {}

        } else {
            ctx = '';
        }
      
        let tempPlusStart = 0;
        let result = []
        var start = 0;
        // let limit = 82;
        let limit = 65;
        for (let i = 0; i <= ((ctx.length) / limit + 1); i++) {
            // find last char                      

            var length = start + limit;

            var tempString = ctx.slice(start, length);
            var focusVowls = (tempString.match(/["่","้","๋","๊","็","ั","ี","ึ","ื","ิ","ุ","ู","์","ั"]/g) || []).length;
            // console.log(tempString,focusVowls);
            length = length + (focusVowls);

            var pre = ctx[length - 2];
            var last = ctx[length - 1];
            var next = ctx[length];


            // start += tempPlusStart;

            tempPlusStart = 0;


            var vowels = ["า", "ำ", "ะ", "่", "้", "๋", "๊", "็", "ั", " ", "ี", "ึ", "ื", "ิ", "ุ", "ู", "์"];
            var vowels2 = ["เ", "ไ", "ใ", "แ", "ั", " "];

            var result1 = vowels.includes(last);
            var result2 = vowels2.includes(last);

            var result3 = vowels.includes(next);
            var result4 = vowels2.includes(pre);
            // console.log(pre,last,next,result1,result2,result3);
            if (result3) {
                //next is ["า", "ำ", "ะ","่","้","๋","๊","็","ั", " "];    
                if (next !== ' ') {
                    // console.log('44444444444');
                    length -= 1;
                    tempPlusStart -= 1;
                    if (!(/^[ก-ฮa-zA-Z]+$/ig.test(last))) {
                        // console.log('55555555555555');
                        length -= 1;
                        tempPlusStart -= 1;
                    }

                    if (result4) {
                        // console.log('6666666');
                        length -= 1;
                        tempPlusStart -= 1;

                    }
                }

            } else if (!(/^[ก-ฮa-zA-Z]+$/ig.test(last)) && !result1) {
                //check should plus or minus          
                if (result2) {
                    // vowels2
                    // console.log('1111111111');
                    length -= 1;
                    tempPlusStart -= 1;
                    // if(!(/^[ก-ฮa-zA-Z]+$/ig.test(pre))){ 
                    //     length -= 1;
                    //     tempPlusStart-= 1;
                    // }
                } else {
                    if (!(/^[ก-ฮa-zA-Z]+$/ig.test(next)) && !result3) {
                        // console.log('2222222222');
                        length -= 1;
                        tempPlusStart -= 1;
                    } else {
                        // console.log('33333333333');
                        length += 1;
                        tempPlusStart += 1;
                    }
                }


            }

            result.push(ctx.slice(start, length) + " ");
            start = + length;
            // console.log('--------------------------------------');                         

        }
        return result.join(' ')
    }

    const styles = StyleSheet.create({

        page: {
            paddingBottom: 30
        },
        footer: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            padding: 10,
            display: 'flex',
            flexDirection: 'row',
        },

        footerTextR: {
            textAlign: 'right',
            fontSize: 10,
            fontFamily: 'SarabunRegular',
            lineHeight: 1.5,
            color: '#828282',
        },

        footerTextL: {
            textAlign: 'left',
            fontSize: 10,
            fontFamily: 'SarabunRegular',
            lineHeight: 1.5,
            color: '#828282',
        },

        header: {
            borderBottomWidth: 1,
            borderBottomColor: '#C4C4C4',
            color: '#000000',
            margin: 30,
            marginBottom: 10,
            display: 'flex',
            flexDirection: 'row',
            paddingBottom: 10,
        },
        headerLeft: {
            textAlign: 'left',
            flex: 1,
            alignSelf: 'center',
            display: 'flex',
            flexDirection: 'row',

        },
        headerRight: {
            textAlign: 'right',
            flex: 1,

        },
        HLB: {
            fontSize: 14,
            fontWeight: 900,
            lineHeight: 1.5,
            color: '#000000',
            fontFamily: 'SarabunBold',
        },
        HLR: {
            fontSize: 10,
            lineHeight: 1.5,
            color: '#000000',
            fontFamily: 'SarabunRegular',
        },
        image: {
            width: "100%",
        },
        logo: {
            paddingRight: 5,
            width: "15%",
        },
        header100: {
            borderBottomWidth: 1,
            borderBottomColor: '#C4C4C4',
            color: '#000000',
            margin: 30,
            marginBottom: 10,
            display: 'flex',
            flexDirection: 'row',
            paddingBottom: 10,
        },
        logo1: {
            paddingRight: 5,
            width: "7%",
        },
        THL1: {
            width: "60%",
        },
        THL2: {
            textAlign: 'right',
            width: "33%",
        },
        THL: {
            width: "85%",
        },
        tableRowWhite: {
            padding: 10,
            display: 'block',
            flexDirection: 'row',
        },
        divRow: {
            color: '#000000',
            padding: 30,
            paddingBottom: 0,
            paddingTop: 0,
            display: 'flex',
            flexDirection: 'row',
            // overflowWrap: 'anywhere',
            // whiteSpace: 'break-spaces',
        },
        divRow2: {
            color: '#000000',
            padding: 30,
            paddingBottom: 0,
            paddingTop: 0,
            display: 'flex',
            flexDirection: 'row',
            // overflowWrap: 'anywhere',
            // whiteSpace: 'break-spaces',
        },
        textBlue: {
            fontSize: 14,
            color: '#3765D1',
            lineHeight: 1.5,
            fontFamily: 'SarabunRegular',

        },
        boxLeft: {
            textAlign: 'left',
            flex: 1,
            alignSelf: 'left',
            display: 'flex',
            flexDirection: 'row',
        },
        boxRight: {
            textAlign: 'right',
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'right',
        },
        icon1: {
            marginLeft: 100,
            paddingRight: 0,
            width: "10%",
        },
        width45: {
            width: "45%",
            textAlign: 'right',
        },
        width50: {
            width: "50%",
            textAlign: 'right',
        },
        titleCenter: {
            textAlign: 'center',
            fontSize: 16,
            fontFamily: 'SarabunBold',
            // paddingBottom: 10,
            paddingTop: 10,
            lineHeight: 1.5,
        },
        titleBlueCenter: {
            textAlign: 'center',
            fontSize: 16,
            fontFamily: 'SarabunBold',
            color: '#3765D1',
            // paddingBottom: 10,
            paddingTop: 10,
            lineHeight: 1.5,
        },
        subTitleCenter: {
            textAlign: 'center',
            fontSize: 14,
            color: '#3765D1',
            fontFamily: 'SarabunBold',
            paddingTop: 10,
            lineHeight: 1.5,
        },
        normalText: {
            color: '#000000',
            fontSize: 14,
            fontFamily: 'SarabunRegular',
            lineHeight: 1.5,
        },
        normalTextCenter: {
            color: '#000000',
            fontSize: 14,
            fontFamily: 'SarabunRegular',
            textAlign: 'center',
            lineHeight: 1.5,
        },
        width100NormalText: {
            color: '#000000',
            fontSize: 14,
            fontFamily: 'SarabunRegular',
            width: "100%",
            lineHeight: 1.5,
            whiteSpace: 'nowrap',
            // textAlign: 'justify',
            overflowWrap: 'anywhere',
            whiteSpace: 'break-spaces',
        },
        width33: {
            width: "33.33%",
            marginBottom: 5
        },
        width100: {
            width: "100%"
        },
        image2: {
            width: "90%",
            border: 1,
            borderColor: '#000000',
            margin: 10,
            marginBottom: 0,
            borderRadius: '12'
        },
        T16Center: {
            width: "100%",
            textAlign: "center",
            fontSize: 16,
            fontFamily: 'SarabunBold',
            lineHeight: 1.5,
        },
        divRowBoxBlue: {
            backgroundColor: '#F4F8FF',
            marginHorizontal: 30,
            marginVertical: 10,
            paddingHorizontal: 20,
            paddingVertical: 10,
            display: 'flex',
            flexDirection: 'row',
            borderWidth: 1,
            borderColor: '#D5E3FB',
        },
        boxLeftBlock: {
            textAlign: 'left',
            width: "75%",
            alignItems: 'left',
        },
        boxRightBlock: {
            textAlign: 'right',
            width: "25%",
            alignItems: 'right',
        },
        T14Left: {
            fontFamily: 'SarabunRegular',
            fontSize: 14,
            width: "100%",
            textAlign: "left",
            color: '#000000',
            lineHeight: 1.5,
        },
        T14RightBold: {
            fontFamily: 'SarabunBold',
            fontSize: 14,
            width: "100%",
            textAlign: "right",
            color: '#000000',
            lineHeight: 1.5,
        },
        ansBox: {
            padding: 10,
            borderWidth: 1,
            borderColor: '#828282',
            marginHorizontal: 30,
            marginVertical: 10,
            borderRadius: 12,
        },
        lastAnsBox: {
            padding: 10,
            borderWidth: 1,
            borderColor: '#828282',
            marginHorizontal: 30,
            marginTop: 10,
            borderRadius: 12,
        },
        image1: {
            paddingTop: 10,
            paddingBottom: 10,
            textAlign: 'center'
        },
        image3: {
            paddingTop: 10,
            paddingBottom: 10,
            paddingHorizontal: 50,
            textAlign: 'center'
        },
        // textText: {
        //     fontFamily: 'SarabunRegular', 
        //     fontSize: 14,      
        //     lineHeight: 1.5,
        //     wordBreak: 'breakAll',
        //     display:'flex',
        //     flexDirection:'row'
        // }

    });

    return (
        // <a href onClick={() => savePdf(StudentReport(), "newpdf.pdf") } className="click-pointer">Click for Download</a>
        <div>
            <div style={{ 'height': '100vh' }} class="text-center m-auto">
                <div class="loader">Loading...</div>
                <h2 style={{ "color": "#3765D1" }}>Loading...</h2>
            </div>
        </div>
    )
}

export default ExportReportFriendshipTarget;